import { render, staticRenderFns } from "./EditorV.vue?vue&type=template&id=0064fffa&"
import script from "./EditorV.vue?vue&type=script&lang=js&"
export * from "./EditorV.vue?vue&type=script&lang=js&"
import style0 from "./EditorV.vue?vue&type=style&index=0&id=0064fffa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports